import React, { FunctionComponent, useRef, useState } from 'react';

import styles from './TiktokPostCard.module.scss';
import PostCardTopBar from '../PostCardTopBar';
import UserInformation from '../UserInformation';
import { checkTranslated } from 'app/utils/helpers';
import {
  useHandleNavigateInfluencerOrEntity,
  useOpenModalToAddUserAsInfluencer,
} from 'app/utils/check-influencer-user';
import { _t } from 'app/utils/i18n';
import { storeInfluencerAsTiktok } from 'influencers/Requests';
import PostCardTextContent from '../PostCardTextContent';
import DefaultVideo from '../../assets/images/defaultVideo.png';
import { useModal } from 'app/context/Modal';
import { BluePlayArrowIcon, MusicIcon } from 'app/assets/images/icons';
import SwiperCore, { Navigation, Virtual, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/swiper.scss';
import { count } from 'console';
import { nFormatter } from 'app/utils/numbersFormater';
import DateLocation from '../DateLocation';
import TweetCardContent from '../TweetCardContent';
import ConversationPopup from '../ConversationPopup';
import {
  getTiktokCommentsDataList,
  getTiktokRegrabReplies,
} from 'posts/Requests';
import AudioTextRow from '../AudioTextRow';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { path } from 'app/utils/path';
import TiktokPostCardMedia from '../TiktokPostCardMedia';
interface Props {
  data: any;
  columnType?: string;
  isTemplate?: boolean;
  compId: string;
  isReport?: boolean;
  withoutSlider?: boolean;
  withBigSize?: boolean;
  isContentClickable?: boolean;
  detailsUrl?: string;
  showConversationPopupFlag?: boolean;
  commentsActionRow?: boolean;
  showFavorite?: boolean;
}

const TiktokPostCard: FunctionComponent<Props> = ({
  data,
  columnType,
  isTemplate,
  compId,
  isReport,
  isContentClickable,
  detailsUrl,
  withoutSlider,
  withBigSize,
  showConversationPopupFlag,
  commentsActionRow,
  showFavorite,
}) => {
  const [isTranslated, setIsTranslated] = useState<boolean>(false);
  const modal = useModal();

  const [openModalToAddUserAsInfluencer] = useOpenModalToAddUserAsInfluencer(
    storeInfluencerAsTiktok,
  );
  const [showConversationPopup, setShowConversationPopup] = useState(false);

  const [handleNavigateInfluencerOrEntity] =
    useHandleNavigateInfluencerOrEntity();

  const translationToggle = () => {
    if (isTranslated === true) {
      setIsTranslated(false);
    } else {
      setIsTranslated(true);
    }
  };
  const RepliesConversationsMutation = useMutation(getTiktokRegrabReplies, {
    onSuccess: () => {
      modal.show({
        onOkText: _t('ok'),
        message: `${_t('basic:working_on_grabbing')} ${_t('posts:reply_conversation')} ${_t(
          'basic:you_will_be_notified',
        )}`,
        onOk: () => {
          modal.hide();
        },
        hideCancel: true,
      });
    },
    onError: (err: any) => {
      toast.error(<span>{err?.response?.data?.message}</span>);
    },
  });
  const regrabRepliesMenuOption = [
    {
      title: _t('posts:regrab_reply_conversation'),
      mutateFun: RepliesConversationsMutation,
      lastGrabbed: data?.comment_last_grabbed_on,
    },
  ];
  const handelOpenImageVideo = (index = 0) => {
    modal.show({
      imageUrls: data?.attachments,
      imageIndex: index,
    });
  };
  const RenderActionRow = () => {
    const [swiperInstance, setSwiperInstance] = useState(0);

    const slideData = [
      {
        name: _t('influencers:comments'),
        count: data?.comments_count,
      },
      {
        name: _t('influencers:likes'),
        count: data?.likes_count,
      },
      {
        name: showFavorite
          ? _t('posts:favorites')
          : _t('influencers:bookmarks'),
        count: data?.bookmarks_count,
      },
      {
        name: _t('influencers:shares'),
        count: data?.shares_count,
      },
      {
        name: _t('influencers:plays'),
        count: data?.play_count,
      },
      {
        name: _t('influencers:downloads'),
        count: data?.downloads_count,
      },
    ];
    const commentsData = [
      {
        name: _t('influencers:likes'),
        count: data?.likes_count,
      },

      {
        name: _t('influencers:replies'),
        count: data?.replies_count,
        hidden: !!data?.is_reply,
      },
    ];
    const currentActionData = commentsActionRow ? commentsData : slideData;
    return withoutSlider ? (
      <div
        className={styles.rowActionItems}
        style={{
          justifyContent: commentsActionRow ? 'flex-start' : 'space-between',
        }}
      >
        {currentActionData?.map(
          (
            multi: { name?: string; count?: number; hidden?: boolean },
            index: number,
          ) => {
            return multi?.hidden ? (
              <></>
            ) : (
              <div className={styles.item} key={index}>
                <span>{multi?.name}</span>
                <span>{multi?.count! > 0 ? nFormatter(multi?.count) : 0}</span>
              </div>
            );
          },
        )}
      </div>
    ) : (
      <Swiper
        spaceBetween={5}
        slidesPerView={3}
        navigation
        grabCursor={true}
        slidesPerGroup={3}
        enabled={slideData?.length > 3}
        className={styles.actions}
        onSlideChange={(swiper) => {
          setSwiperInstance(swiper?.activeIndex);
        }}
      >
        {slideData?.map(
          (multi: { name?: string; count?: number }, index: number) => {
            return multi.count! > 0 ? (
              <SwiperSlide key={index}>
                <div className={styles.item}>
                  <span>{multi?.name}</span>
                  <span>{nFormatter(multi?.count)}</span>
                </div>
              </SwiperSlide>
            ) : (
              <></>
            );
          },
        )}
      </Swiper>
    );
  };
  return (
    <div
      className={`${styles.TiktokPostCard} post_card_url`}
      data-type={data?.post_url}
      id={`${compId}-TiktokPostCard-${data.id}`}
    >
      {showConversationPopup && (
        <ConversationPopup
          commentsConversation={{ postData: data }}
          isOpen={showConversationPopup}
          handleOpen={() => setShowConversationPopup(true)}
          handleClose={() => setShowConversationPopup(false)}
          getCommentsDataList={getTiktokCommentsDataList}
          getRegrabReplies={getTiktokRegrabReplies}
          withAudioRow
          openModalToAddInfluencer={(username: string, url: string) =>
            openModalToAddUserAsInfluencer(
              username,
              url,
              _t('influencers:open_in_tiktok'),
            )
          }
        />
      )}
      <div className={styles.TiktokPostCard__Wrapper}>
        {!isReport && !isTemplate ? (
          <PostCardTopBar
            translationToggle={translationToggle}
            compId={`${compId}-TiktokPostCard-${data.id}`}
            platformUrl={data?.post_url}
            content={data?.content || data?.text?.original}
            contentTranslated={data?.content_translated || data?.text?.arabic}
            postId={data?.id}
            postLanguages={data?.languages}
            platform={data?.platform}
            showReplyIcon={!!data?.is_reply}
            showConversationPopupFlag={showConversationPopupFlag}
            showConversationPopup={() => setShowConversationPopup(true)}
            extraOptions={regrabRepliesMenuOption}
            showRegrab={!data?.is_reply && commentsActionRow}
            showSponsored={!!data?.is_ad}
          />
        ) : (
          <></>
        )}
        <div
          className={`${styles.TiktokPostCard__Wrapper__content}`}
          style={{ padding: withBigSize ? '10px 20px 20px' : undefined }}
        >
          <UserInformation
            profileImage={data?.profile_image_url}
            name={
              checkTranslated(
                data?.influencer?.name?.original,
                data?.influencer?.name?.arabic,
              ) || data?.username
            }
            username={data?.username}
            isVerified={data?.is_verified}
            handleInfluencerOrEntity={() =>
              handleNavigateInfluencerOrEntity(data?.influencer)
            }
            isClickable={!isTemplate}
            isUserAdded={data?.influencer?.influencer_id !== 0}
            openModalToAddInfluencer={() =>
              openModalToAddUserAsInfluencer(
                data?.username,
                data?.influencer?.url,
                _t('influencers:open_in_tiktok'),
              )
            }
            isSmallerSize
            hideAtIcon
          />
          <div className={styles.caption}>
            <PostCardTextContent
              content={data?.content ? data?.content : data?.text}
              storeInfluencerName={storeInfluencerAsTiktok}
              isReport={isReport}
              isTranslated={isTranslated}
              mentions={data?.post_mentions}
              openText={_t('influencers:open_in_tiktok')}
              isContentClickable={isContentClickable}
              detailsUrl={
                detailsUrl ||
                `${path.posts.TIKTOK_POST_DETAILS_URI}/${data?.id}`
              }
            />
          </div>
          {isReport && <div style={{ margin: '1rem' }}></div>}
          {data?.parent_comment && data?.parent_comment?.id !== 0 && (
            <TweetCardContent
              parentTweetData={data?.parent_comment}
              openModalToAddInfluencer={(url,username) =>
                openModalToAddUserAsInfluencer(
                  username,
                  url,
                  _t('influencers:open_in_tiktok'),
                )
              }
              handleInfluencer={(influencer) =>
                handleNavigateInfluencerOrEntity(influencer)
              }
              isQuote
              isInstagram
            />
          )}
          <AudioTextRow data={data} />
          {(data?.attachments?.length !== 0 && data?.attachments) && (
            <TiktokPostCardMedia attachments={data?.attachments} />
          )}
          <div style={{ marginBottom: '20px' }}>
            <DateLocation
              created_at={!!data?.time?.length ? '' : data?.published_at}
              location={data?.location}
              time={data?.time}
            />
          </div>
          <RenderActionRow />
        </div>
      </div>
    </div>
  );
};

export default TiktokPostCard;
